export default __webpack_public_path__ + "static/BrownEntrataWeb-Regular-62caf793217e50b69090665ab2702d3f.woff";